// @flow
import React from "react";

const UserContext = (React.createContext({
  username: "",
  userId: "",
  isSuperAdmin: false,
  organization: [],
}): React$Context<{
  username: string,
  userId: string,
  isSuperAdmin: boolean,
  organization?: Array<string> | string,
  ...
}>);

export default UserContext;
